import { currencyLabelWhole } from "helpers";

interface MinimumVendNoticeProps {
    minimumVendAmount: number;
    hasCollections: boolean;
    collectionTotal: number;
}

export default function MinimumVendNotice({
    minimumVendAmount,
    hasCollections,
    collectionTotal,
}: MinimumVendNoticeProps) {
    return (
        <section
            className={`rounded-xl border-2 px-4 py-4 ${
                hasCollections
                    ? "border-amber-400 bg-amber-50"
                    : "border-engage-500 bg-engage-100"
            }`}
            aria-labelledby="minimum-vend-heading"
        >
            <div className="flex items-start gap-3">
                <div
                    className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                        hasCollections ? "bg-amber-200 text-amber-900" : "bg-engage-200 text-engage-800"
                    }`}
                    aria-hidden
                >
                    !
                </div>

                <div className="min-w-0 flex-1">
                    <p
                        id="minimum-vend-heading"
                        className={`text-xs font-bold uppercase tracking-wide ${
                            hasCollections ? "text-amber-900" : "text-engage-800"
                        }`}
                    >
                        Required minimum for your next vend
                    </p>

                    <p
                        className={`mt-1 text-3xl font-extrabold leading-none ${
                            hasCollections ? "text-amber-950" : "text-engage-900"
                        }`}
                    >
                        {currencyLabelWhole(minimumVendAmount)}
                    </p>

                    {hasCollections ? (
                        <p className="mt-3 text-sm leading-relaxed text-amber-950/90">
                            You have <strong>{currencyLabelWhole(collectionTotal)}</strong> in collections due.
                            Your next vend <strong>must be at least {currencyLabelWhole(minimumVendAmount)}</strong> —
                            vending a lower amount will not be accepted.
                        </p>
                    ) : (
                        <p className="mt-3 text-sm leading-relaxed text-engage-900/90">
                            Your next vend <strong>must be at least {currencyLabelWhole(minimumVendAmount)}</strong>.
                            You cannot purchase less than this amount.
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
}
